/*
 * @Description: 
 * @Author: Mayer
 * @Date: 2020-11-13 21:14:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-11-13 21:36:49
 */
export default {
  lang: "法语",
  landing: {
    name1: "Ouvrir l'application Carlcare",
    name2: "Faire une réservation",
    name3: "Utilisez l'application Carlcare, vous pouvez vérifier ",
    name4: "les informations de la commande à tout moment!",
  },
  birLanding: {
    name1: "Modèle de l’appareil:",
    name2: "Description du problème:",
    name3: "Sélectionnez un magasin de détail",
    name4: "Magasin de services:",
    name5: "Heure de réservation:",
    name6: "Veuillez décrire le problème de votre appareil en détail!",
    name7: "Veuillez sélectionner la date ou l'heure!",
    name8:"Veuillez remplir vos renseignements personnels avec précision afin que nous puissions vous contacter!",
    name9: "Le temps de réservation disponible est le suivant!",
    name10: "Veuillez entrer votre numéro de téléphone",
    name11: "Prix",
    name12: "Informations personnelles:",
    name13: "S'il vous plaît entrez votre nom",
    name14: "Soumettre",
    name15: "Annuler",
    name16: "OK",
  },
  birRecord: {
    name1: "Marque",
    name2: "Modèle",
    name3: "Article",
    name4: "Prix",
    name5: "Rappel amical:",
    name6:"Ces prix sont juste pour la référence, et le prix réel edépend de l'état de votre appareil.",
    name7:"S'il n'y a pas de symbole spécial, l'unité de prix est l'unité de monnaie locale.",
    name8:"Désolée! Aucune information sur les prix disponibles sur le site de ce pays.",
  },
  birRules: {
    name1: "Pas encore de données",
    name2: "Fournisseur de service:",
    name3: "Marque de service:",
    name4: "Téléphone:",
    name5: "Quantité de la commande:",
    name6: "Évaluation du service",
    name7: "Environnement de service:",
    name8: "Attitude de service:",
    name9: "Efficacité du service:",
    name10: "Qualité du service:",
    name11: "Évaluation du client ",
    name12: "",
  },
};